import { useCallback } from 'react';
import { GetMeQuery } from '@/generated/gql/graphql';
import useFeature from '@/lib/features';
import useUserDetails from '@/shared/data/useUserDetails';
import useAccountFeatureConfigs from '@/shared/providers/useAccountFeatureConfigs';
import { isProd } from '@/utils/env';

const useEnableUnification = () => {
  const isProdEnv = isProd();
  const { wasSmbMigrated } = useAccountFeatureConfigs();
  const [enableHomepageForAccounts] = useFeature('enterprise-ui_enableHomepageForAccounts');
  const [enableHomepageForEntAccounts] = useFeature('enterprise-ui_enableHomepageForEntAccounts');
  const { data: segment } = useUserDetails(useCallback((user: GetMeQuery) => user.me?.account?.segment, []));

  // In non-prod, always enabled
  if (!isProdEnv) {
    return true;
  }

  // In prod, check if
  // account was migrated from SMB or
  // enableHomepageForAccounts is enabled or
  // enableHomepageForEntAccounts is enabled and account is not sun spot
  // NOTE: enableHomepageForEntAccounts uses a harness segment to determine if the account is eligible for the feature
  return wasSmbMigrated || enableHomepageForAccounts || (enableHomepageForEntAccounts && segment !== 'Sun');
};

export default useEnableUnification;
